// extracted by mini-css-extract-plugin
export var Banner = "index-module--Banner--O6CfZ";
export var BannerIcon = "index-module--BannerIcon--y-knH";
export var Bottom = "index-module--Bottom--Vct34";
export var Card = "index-module--Card--FfDd1";
export var Consult = "index-module--Consult--dMd1f";
export var Entertain = "index-module--Entertain--Wcu+4";
export var Product = "index-module--Product--XJrqz";
export var logoWrap = "index-module--logoWrap--HPfFj";